export default {
	section_banner: {
		title: {
			one: 'ワンテザー',
		},
		main_title: {
			one: 'Own Point',
			two: 'System',
		},
		paragraph: {
			one: 'Fast and secure self-point system. No fatigue with fixed exchange rates. Enjoy stability, speed, and total control.',
		},
		cta_buttons: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},

	offline_store_sec: {
		title: {
			one: 'Connects To All Systems',
		},
		sub_title: {
			one: 'Offline',
			two: 'Stores',
			three: '&',
			four: 'Online',
			five: 'Stores',
		},
		paragraph: {
			one: 'All You Need Is JPWorldPay. With JPWorldPay, you can send and receive money, make purchases, earn rewards, and manage your funds—all from one easy-<br />to-use platform. It is fast, secure, and designed to meet all your everyday financial needs in one	place.',
		},
	},

	question_trade: {
		title: {
			one: 'Money Transaction',
		},
		sub_title: {
			one: 'Kiosks',
			two: ' & ',
			three: 'POS',
			four: 'Machines Pay Freely Anywhere',
		},
		paragraph: {
			one: 'Kiosks & POS Machines – Pay Freely Anywhere. With JPWorldPay, you can make payments effortlessly at kiosks and POS machines across various locations.',
			two: 'Whether you’re shopping in-store, dining out, or using a self-service kiosk, JPWorldPay ensures smooth, secure, and contactless transactions-giving you the freedom to pay anytime, anywhere.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	charging_sec: {
		title: 'Recharge Instantly',
		sub_title: {
			one: 'Convenient Charging',
		},
		paragraph: {
			one: 'Recharge instantly with your desired cryptocurrency and credit card. JPWorldPay makes it simple to top up your balance using the method that suits you best.',
			two: 'Whether you prefer using digital assets or traditional payment options, recharging is fast, convenient, and secure—ensuring uninterrupted access to all your JPWorldPay services.',
		},
		cta_buttons: {
			one: 'CREATING A JPWORLDPAY LINK',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
